import { useState } from 'react';
import { useDispatch } from 'react-redux';
import A from './ActionCreators';
import WelcomeFeatures from "./WelcomeFeatures";
export default function TutorialScene(){

  const dispatch = useDispatch();
  

  let tutorialOptions = [
    {_id:"blot-gel",label:"Blot/gel figure creation"},
    {_id:"microscop",label:"Microscopy figure creation"}
  ]

  const [selected,setSelected] = useState();

return (
    <div class="fair-padding sg-row">
      <div class="half">
      {tutorialOptions.map(opt =>  {
        return (
          <div onClick={() => {
            setSelected(opt);
          }} style={{
            fontSize:24,
          }} class={`clickable-text`}>{opt.label}</div>
        )
      })}
      </div>

      
      {selected && <div>
        <button onClick={() => {
          //dispatch(A.setUiMode({}));
          dispatch(A.launchTutorial());
        }} class="btn btn-primary">
          {`Start tutorial: ${selected.label}`}
        </button>
        <div>
          Tutorial video preview.
        </div>
      </div>}
    </div>
  )
}
